import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=4a72f40c&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"
import style0 from "./Payments.vue?vue&type=style&index=0&id=4a72f40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72f40c",
  null
  
)

export default component.exports